import styled from 'styled-components';
import { AllieColors } from '../../../common/color.types';
import { AllieHeader } from '../../../components/Toolbar/Header';

export const LogoutButtonMobileAppContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: var(--allie-radius-xxl);
  background: var(--allie-color-white);
  padding: var(--allie-spacing-xl) var(--allie-spacing-md) var(--allie-spacing-xl)
    var(--allie-spacing-3xl);
  ion-button::part(native) {
    overflow: visible;
  }
`;

export const AllieHeaderMobileAppStyled = styled(AllieHeader)<{
  color?: AllieColors;
  isIOS?: boolean;
}>`
  padding: ${({ isIOS }) => (isIOS ? 'env(safe-area-inset-top)' : '24px')} 12px 0 20px;
  height: auto;
  min-height: auto;
  background: ${({ color }) =>
    color ? `var(--allie-color-${color})` : 'var(--allie-color-neutral-10)'};
  align-items: center;
  display: flex;
  /* padding: 4px 20px; */
  box-sizing: border-box;
  border-bottom: ${({ color }) => (color ? 'none' : '1px solid var(--allie-color-neutral-30)')};
  justify-content: space-between;
  position: auto;

  &::after {
    content: none;
  }
`;
